import { formatNumber } from '@app/utils/formatting'
import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { NavLink } from 'react-router-dom'
import { Badge, NavItem } from 'reactstrap'

export interface INavTabItemProps {
  badgeCount?: number
  badgeSuffix?: string
  exact?: boolean
  iconName: IconName
  iconPrefix?: IconPrefix
  label: string
  to: string
}

export class NavTabItem extends React.Component<INavTabItemProps> {
  public render() {
    return (
      <NavItem>
        <NavLink
          activeClassName='active'
          className='nav-link'
          exact={this.props.exact}
          to={this.props.to}
        >
          <FontAwesomeIcon
            icon={[this.props.iconPrefix || 'fal', this.props.iconName]}
          />
          <span className='ml-2 d-none d-xl-inline'>{this.props.label}</span>
          {this.props.badgeCount !== undefined && this.props.badgeCount > 0 && (
            <Badge className='ml-2'>
              {this.props.badgeCount > 100
                ? '99+'
                : formatNumber(this.props.badgeCount, 0)}
              {this.props.badgeSuffix}
            </Badge>
          )}
        </NavLink>
      </NavItem>
    )
  }
}
